import { Md5 } from 'ts-md5';
import Service from "./Service";
import Cookies from "js-cookie";
import store from "../vue/planning/store/store.ts";


export default class WiypService extends Service {
	constructor() {
		super()
		this.serviceUrl = `https://api.travelski.com/wiyp`;
		this.mandatoryFields = {
			getWiypPrices: [
				"packageId",
				"packCode",
				"liheId",
				"prestIds",
				"startDate",
				"endDate",
				"familyComposition",
				"site",
				"acceptLanguage",
			],
		}
	}

	getLanguageFromCompany(domain) {
        if (domain==='cse.travelski.com') {
            return Cookies.get('companyLang') ?? 'fr'
        }
        return undefined;
    }

	getCompany(domain) {
		return domain === 'cse.travelski.com' ? Cookies.get('company') ?? undefined : undefined;
	}
	
	async getWiypPrices(requestData) {
        
        this.checkMandatoryFields(requestData, "getWiypPrices")

		if ( requestData.site !== 'cse.travelski.com' && requestData.packCode === "HS")
			throw new Error("cannot request prices for HS package");		

		const query = {
			packageId: requestData.packageId,
			packCode: requestData.packCode,
			liheId: requestData.liheId,
			prestIds: requestData.prestIds,
			startDate: requestData.startDate,
			endDate: requestData.endDate,
			familyComposition: requestData.familyComposition,
			site: requestData.site,
			language: this.getLanguageFromCompany(requestData.site) ?? requestData.acceptLanguage.slice(0, 2)
		};	

		if(requestData.origin) {
			query.origin = requestData.origin
		}
		
		const company = this.getCompany(requestData.site);
		if (company) {
			query.company = company;
			query.packageId = requestData.packCode === "HS" ? `${requestData.liheId}HS` : requestData.packageId;
		}		

		const orderedQuery = Object.keys(query).sort().reduce((obj, key) => {
			if (query[key] !== null && query[key] !== undefined && query[key] !== '') {
				obj[key] = query[key];
			}
			return obj;
		}, {});
		const hashKey = Md5.hashStr(JSON.stringify(orderedQuery));

		const queryString = Object
			.keys(orderedQuery)
			.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(orderedQuery[key])}`)
			.join('&');
		
		// ONLY FOR METRICS
		// HERE WE MAKE THE CALL AND DO NOT CARE ABOUT ANSWER
		// console.log('CALL TO WIYP ENDPOINT', hashKey);
		if(queryString.includes("Invalid")) {
			console.error(`querystring is invalid!: ${queryString}`)
		}

		const { data } = await this.axios.get(`${this.serviceUrl}/price/${hashKey}?${queryString}`);
		
		if (data?.fees) {
			store.commit("setFeeFromWIYP", data.fees);
		}
		return data
	}



}
